/* ===========================================================
   GAMEDAY KITS — theme.js  (vanilla, no dependencies)
   =========================================================== */
(function () {
  "use strict";
  var GDK = window.GDK || {};
  var moneyFormat = GDK.moneyFormat || "R{{amount}}";

  document.documentElement.classList.remove("no-js");
  document.documentElement.classList.add("js");

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var withDecimals = whole + "." + parts[1];
    var withoutDecimals = whole;
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withoutDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withoutDecimals);
  }

  function toast(msg) {
    var el = $("#gdkToast");
    if (!el) {
      el = document.createElement("div");
      el.id = "gdkToast";
      el.className = "toast";
      document.body.appendChild(el);
    }
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
    el.querySelector("span").textContent = msg;
    requestAnimationFrame(function () { el.classList.add("show"); });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove("show"); }, 2600);
  }

  /* ---------- mobile menu ---------- */
  var menuBtn = $("[data-menu-open]");
  var mobileMenu = $("[data-mobile-menu]");
  function closeMenu() { if (mobileMenu) { mobileMenu.classList.remove("open"); if (menuBtn) menuBtn.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; } }
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener("click", function () {
      mobileMenu.classList.add("open");
      menuBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    });
    $all("[data-menu-close]", mobileMenu).forEach(function (b) { b.addEventListener("click", closeMenu); });
    $all("a", mobileMenu).forEach(function (a) { a.addEventListener("click", closeMenu); });
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeMenu(); closeCart(); } });

  /* ---------- scroll reveal ---------- */
  var revealEls = $all("[data-reveal]");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else { revealEls.forEach(function (el) { el.classList.add("is-visible"); }); }

  /* ===========================================================
     CART DRAWER + AJAX CART
     =========================================================== */
  var drawer = $("[data-cart-drawer]");
  var overlay = $("[data-cart-overlay]");
  var drawerBody = $("[data-cart-body]");
  var drawerFoot = $("[data-cart-foot]");

  function openCart() { if (drawer) { drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); if (overlay) overlay.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function closeCart() { if (drawer) { drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); if (overlay) overlay.classList.remove("open"); document.body.style.overflow = ""; } }

  $all("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); refreshCart(); openCart(); });
  });
  $all("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  if (overlay) overlay.addEventListener("click", closeCart);

  function updateCount(count) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";
    });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawerBody) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<div class="empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg><p>Your bag is empty.</p><a class="btn btn--gold" href="/collections/all" data-cart-close>Shop the Drop</a></div>';
      if (drawerFoot) drawerFoot.style.display = "none";
      $all("[data-cart-close]", drawerBody).forEach(function (b) { b.addEventListener("click", closeCart); });
      return;
    }
    if (drawerFoot) drawerFoot.style.display = "";
    var html = "";
    cart.items.forEach(function (item, i) {
      var line = i + 1;
      var img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x150$1$2") : "";
      var opts = (item.options_with_values || []).filter(function (o) { return o.value !== "Default Title"; })
        .map(function (o) { return o.value; }).join(" / ");
      var props = "";
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) !== "_" && item.properties[k]) props += k + ": " + item.properties[k] + "  ";
        });
      }
      html += '<div class="cd-item" data-line="' + line + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div></div>') +
        '<div><b>' + item.product_title + "</b>" +
        (opts ? '<p>' + opts + "</p>" : "") +
        (props ? '<p class="props">' + props + "</p>" : "") +
        '<div class="cd-bottom"><div class="cd-qty">' +
        '<button type="button" data-line-minus aria-label="Decrease">&minus;</button>' +
        '<span>' + item.quantity + "</span>" +
        '<button type="button" data-line-plus aria-label="Increase">+</button>' +
        '</div><span class="cd-price">' + formatMoney(item.final_line_price) + "</span></div></div></div>";
    });
    drawerBody.innerHTML = html;
    if (drawerFoot) {
      drawerFoot.querySelector("[data-cart-subtotal]").innerHTML = formatMoney(cart.total_price);
    }
    bindLineEvents();
  }

  function bindLineEvents() {
    $all(".cd-item", drawerBody).forEach(function (row) {
      var line = parseInt(row.getAttribute("data-line"), 10);
      var qtyEl = row.querySelector(".cd-qty span");
      var current = parseInt(qtyEl.textContent, 10);
      row.querySelector("[data-line-plus]").addEventListener("click", function () { changeLine(line, current + 1); });
      row.querySelector("[data-line-minus]").addEventListener("click", function () { changeLine(line, current - 1); });
    });
  }

  function refreshCart() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function addToCart(formData, btn, buyNow) {
    var original = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.innerHTML = buyNow ? "Processing…" : "Adding…"; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: formData
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () {
        if (buyNow) {
          if (btn) btn.innerHTML = "Taking you to checkout…";
          window.location.href = "/checkout";
          return;
        }
        toast("Added to your bag");
        refreshCart();
        openCart();
      })
      .catch(function (err) {
        toast((err && err.description) || "Could not add to bag");
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      })
      .finally(function () { if (!buyNow && btn) { btn.disabled = false; btn.innerHTML = original; } });
  }

  function addToCartJson(payload, btn, buyNow) {
    var original = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.innerHTML = buyNow ? "Processing…" : "Adding…"; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () {
        if (buyNow) {
          if (btn) btn.innerHTML = "Taking you to checkout…";
          window.location.href = "/checkout";
          return;
        }
        toast("Added to your bag");
        refreshCart();
        openCart();
      })
      .catch(function (err) {
        toast((err && err.description) || "Could not add to bag");
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      })
      .finally(function () { if (!buyNow && btn) { btn.disabled = false; btn.innerHTML = original; } });
  }

  $all("form[action*='/cart/add']").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = (e.submitter && e.submitter.matches("[type=submit]")) ? e.submitter : form.querySelector("[type=submit]");
      var buyNow = form.hasAttribute("data-buy-now") && !(e.submitter && e.submitter.hasAttribute("data-cart-btn"));
      var persoEl = form.querySelector("[data-perso]");
      var pT = persoEl ? persoEl.querySelector("[data-perso-toggle]") : null;
      if (pT && pT.checked) {
        var nameV = (persoEl.querySelector("[data-perso-name]").value || "").trim();
        var numV = (persoEl.querySelector("[data-perso-num]").value || "").trim();
        if (!nameV && !numV) { toast("Enter the name or number to print"); return; }
        var qtyEl = form.querySelector("[name=quantity]");
        var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var props = {};
        if (nameV) props["Name"] = nameV;
        if (numV) props["Number"] = numV;
        addToCartJson({ items: [
          { id: parseInt(form.querySelector("[name=id]").value, 10), quantity: qty, properties: props },
          { id: parseInt(persoEl.getAttribute("data-perso-id"), 10), quantity: qty }
        ]}, btn, buyNow);
        return;
      }
      addToCart(new FormData(form), btn, buyNow);
    });
  });

  /* ===========================================================
     PRODUCT PAGE — gallery, variants, qty, sticky bar
     =========================================================== */
  var product = window.__gdkProduct;
  var pdpForm = $("[data-pdp-form]");

  // gallery
  $all("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    $all("[data-thumb]", gallery).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        if (main && full) main.src = full;
        $all("[data-thumb]", gallery).forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
      });
    });
  });

  // qty steppers
  $all("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelector("[data-qty-minus]").addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    wrap.querySelector("[data-qty-plus]").addEventListener("click", function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // variant selection
  if (product && pdpForm) {
    var idInput = pdpForm.querySelector("[name=id]");
    var priceEl = $("[data-pdp-price]");
    var compareEl = $("[data-pdp-compare]");
    var saveEl = $("[data-pdp-save]");
    var addBtn = pdpForm.querySelector("[data-add-btn]");
    var cartBtn = pdpForm.querySelector("[data-cart-btn]");
    var sbPrice = $("[data-sb-price]");
    var optionCount = (product.options || []).length;
    var selected = [];

    // init selection from first available variant
    var firstAvail = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    if (firstAvail) selected = firstAvail.options.slice();

    function findVariant() {
      return product.variants.filter(function (v) {
        for (var i = 0; i < optionCount; i++) { if (v.options[i] !== selected[i]) return false; }
        return true;
      })[0];
    }

    function valueAvailable(optIndex, value) {
      // does at least one available variant exist with this value at optIndex,
      // matching the other currently-selected options?
      return product.variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optIndex] !== value) return false;
        for (var i = 0; i < optionCount; i++) {
          if (i !== optIndex && selected[i] && v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function render() {
      $all("[data-option-index]", pdpForm).forEach(function (group) {
        var oi = parseInt(group.getAttribute("data-option-index"), 10);
        $all("[data-value]", group).forEach(function (btn) {
          var val = btn.getAttribute("data-value");
          btn.classList.toggle("selected", selected[oi] === val);
          var ok = valueAvailable(oi, val);
          btn.classList.toggle("soldout", !ok);
          btn.disabled = !ok;
        });
      });
      var v = findVariant();
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = formatMoney(v.price);
        if (sbPrice) sbPrice.innerHTML = formatMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.innerHTML = formatMoney(v.compare_at_price);
            compareEl.style.display = "";
          } else { compareEl.style.display = "none"; }
        }
        if (saveEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            var saved = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
            saveEl.textContent = "Save " + saved + "%";
            saveEl.style.display = "";
          } else {
            saveEl.style.display = "none";
          }
        }
        if (addBtn) {
          if (v.available) { addBtn.disabled = false; addBtn.textContent = "Buy Now"; }
          else { addBtn.disabled = true; addBtn.textContent = "Sold Out"; }
        }
        if (cartBtn) cartBtn.disabled = !v.available;
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
        if (cartBtn) cartBtn.disabled = true;
      }
    }

    $all("[data-option-index]", pdpForm).forEach(function (group) {
      var oi = parseInt(group.getAttribute("data-option-index"), 10);
      $all("[data-value]", group).forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          selected[oi] = btn.getAttribute("data-value");
          render();
        });
      });
    });
    render();
  }

  // sticky buy "choose size" scrolls to options / add
  $all("[data-sticky-add]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (pdpForm) {
        var b = pdpForm.querySelector("[data-add-btn]");
        if (b && !b.disabled) { b.click(); return; }
        var firstOpt = pdpForm.querySelector("[data-option-index]");
        (firstOpt || pdpForm).scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  });

  // Personalisation opt-in: reveal fields, enable inputs
  var persoBlock = document.querySelector("[data-perso]");
  if (persoBlock) {
    var pTog = persoBlock.querySelector("[data-perso-toggle]");
    var pFields = persoBlock.querySelector("[data-perso-fields]");
    var pN = persoBlock.querySelector("[data-perso-name]");
    var pNo = persoBlock.querySelector("[data-perso-num]");
    pTog.addEventListener("change", function () {
      var on = pTog.checked;
      persoBlock.classList.toggle("is-active", on);
      pFields.hidden = !on;
      pN.disabled = !on; pNo.disabled = !on;
      pN.toggleAttribute("required", on);
      pNo.toggleAttribute("required", on);
      if (!on) { pN.value = ""; pNo.value = ""; }
      if (on) pN.focus();
    });
  }

  /* ===========================================================
     PREDICTIVE SEARCH (lightweight)
     =========================================================== */
  var searchInput = $("[data-predictive-input]");
  var searchResults = $("[data-predictive-results]");
  if (searchInput && searchResults) {
    var timer;
    searchInput.addEventListener("input", function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ""; return; }
      timer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=5", { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { searchResults.innerHTML = '<p class="ps-empty">No matches yet.</p>'; return; }
            searchResults.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img class="ps-img" src="' + p.featured_image.url + '" alt="">' : "";
              return '<a class="ps-item" href="' + p.url + '">' + img + '<span><b class="ps-title">' + p.title + '</b><span class="ps-price">' + (p.price ? formatMoney(parseFloat(p.price) * 100) : "") + "</span></span></a>";
            }).join("");
          })
          .catch(function () {});
      }, 220);
    });
  }
})();

/* ===========================================================
   GDK PREMIUM LAYER (v20) — conversion & motion polish
   - Scroll-reveal choreography (IntersectionObserver, staggered)
   - Header elevation on scroll
   - Mobile sticky quick-buy dock (homepage only)
   All progressive enhancement: no JS = page fully visible.
   =========================================================== */
(function () {
  "use strict";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 1. Scroll reveal ---------- */
  if (!reduced && "IntersectionObserver" in window) {
    var SEL = [
      ".d12-section-head", ".d12-product", ".d12-assist-panel",
      ".d12-proof-grid > div", ".d12-fit-card", ".d12-bundle-card", ".d12-final-card",
      ".v8-section-head", ".v8-product", ".v8-help-card",
      ".v8-need-card", ".v8-trust-grid > div", ".v8-bundle-card", ".v8-final-card", "[data-reveal]"
    ].join(",");
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (nodes.length) {
      /* stagger siblings inside the same parent */
      var counts = new Map();
      nodes.forEach(function (el) {
        var p = el.parentElement;
        var i = counts.get(p) || 0;
        counts.set(p, i + 1);
        el.style.setProperty("--gdk-d", Math.min(i * 90, 360) + "ms");
        el.classList.add("gdk-reveal");
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("gdk-inview");
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
      nodes.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- 2. Header elevation on scroll ---------- */
  var header = document.querySelector(".site-header");
  if (header) {
    var lastY = -1;
    var onScroll = function () {
      var y = window.scrollY || 0;
      if ((y > 8) !== (lastY > 8)) header.classList.toggle("gdk-scrolled", y > 8);
      lastY = y;
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- 3. Mobile sticky quick-buy dock (homepage) ---------- */
  var mobileHome = document.querySelector(".mobile-home-keep");
  if (mobileHome) {
    var dock = document.createElement("div");
    dock.className = "gdk-dock";
    dock.setAttribute("aria-label", "Quick shop");
    dock.innerHTML =
      '<a href="#home-shirt" class="btn btn--gold gdk-dock-btn">Shop Home</a>' +
      '<a href="#away-shirt" class="btn btn--green gdk-dock-btn">Shop Away</a>';
    document.body.appendChild(dock);

    var hero = mobileHome.querySelector(".v8-hero");
    var finalCta = mobileHome.querySelector(".v8-final");
    var heroGone = false, finalSeen = false;
    var apply = function () {
      var show = heroGone && !finalSeen && window.innerWidth < 990;
      dock.classList.toggle("gdk-dock--on", show);
      document.body.classList.toggle("gdk-dock-on", show);
    };
    if ("IntersectionObserver" in window && hero) {
      new IntersectionObserver(function (e) {
        heroGone = !e[0].isIntersecting; apply();
      }, { threshold: 0 }).observe(hero);
      if (finalCta) {
        new IntersectionObserver(function (e) {
          finalSeen = e[0].isIntersecting; apply();
        }, { threshold: 0.1 }).observe(finalCta);
      }
      window.addEventListener("resize", apply, { passive: true });
    }
  }
})();

/* ===========================================================
   GDK FLAGSHIP LAYER (v22)
   - 3D tilt + light glare on desktop hero cards
   - Magnetic hero CTAs (desktop pointer only)
   - Scroll progress bar
   - Cart badge pop on count change
   All gated: pointer:fine / prefers-reduced-motion safe.
   =========================================================== */
(function () {
  "use strict";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* ---------- 1. 3D tilt + glare on desktop hero cards ---------- */
  if (!reduced && fine) {
    document.querySelectorAll(".d12-feature-card").forEach(function (card) {
      var glare = document.createElement("span");
      glare.className = "gdk-glare";
      card.appendChild(glare);
      var raf = null;
      card.addEventListener("pointermove", function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width;   // 0..1
          var y = (e.clientY - r.top) / r.height;   // 0..1
          card.style.setProperty("--rx", ((0.5 - y) * 7).toFixed(2) + "deg");
          card.style.setProperty("--ry", ((x - 0.5) * 9).toFixed(2) + "deg");
          card.style.setProperty("--gx", (x * 100).toFixed(1) + "%");
          card.style.setProperty("--gy", (y * 100).toFixed(1) + "%");
          card.classList.add("gdk-tilting");
        });
      });
      card.addEventListener("pointerleave", function () {
        card.classList.remove("gdk-tilting");
        card.style.setProperty("--rx", "0deg");
        card.style.setProperty("--ry", "0deg");
      });
    });

    /* ---------- 2. Magnetic hero CTAs ---------- */
    document.querySelectorAll(".d12-actions .btn").forEach(function (btn) {
      btn.addEventListener("pointermove", function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.setProperty("--mx", ((e.clientX - r.left - r.width / 2) * 0.12).toFixed(1) + "px");
        btn.style.setProperty("--my", ((e.clientY - r.top - r.height / 2) * 0.22).toFixed(1) + "px");
      });
      btn.addEventListener("pointerleave", function () {
        btn.style.setProperty("--mx", "0px");
        btn.style.setProperty("--my", "0px");
      });
    });
  }

  /* ---------- 3. Scroll progress bar ---------- */
  if (!reduced) {
    var bar = document.createElement("div");
    bar.className = "gdk-progress";
    bar.setAttribute("aria-hidden", "true");
    document.body.appendChild(bar);
    var ticking = false;
    var update = function () {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      bar.style.transform = "scaleX(" + (max > 0 ? Math.min(window.scrollY / max, 1) : 0).toFixed(4) + ")";
    };
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- 4. Cart badge pop ---------- */
  document.querySelectorAll("[data-cart-count]").forEach(function (el) {
    new MutationObserver(function () {
      el.classList.remove("gdk-pop");
      void el.offsetWidth; /* restart animation */
      el.classList.add("gdk-pop");
    }).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();
